<template>
  <div>
    <!-- <h2 class="text-center colorblue">Панель администратора</h2> -->
    <v-card>
      <v-tabs v-model="tab" @change="ChangeTabUM" centered>
        <v-tab v-for="item in items" :key="item">
          {{ item }}
        </v-tab>
      </v-tabs>
    </v-card>
    <v-tabs-items v-model="tab" class="mt-2">
      <v-tab-item>
        <v-card-text>
          <OrganisationTable />
        </v-card-text>
      </v-tab-item>
      <v-tab-item>
        <v-card-text>
          <UsersTableUM />
        </v-card-text>
      </v-tab-item>
      <!-- <v-tab-item>
        <v-card-text>
          <AddTariff />
          <EditTariffs />
        </v-card-text>
      </v-tab-item> -->
      <v-tab-item>
        <v-card-text>
          <EditFirmTarifs />
        </v-card-text>
      </v-tab-item>
      <!-- <v-tab-item>
        <v-card-text>
          <BankRating />
        </v-card-text>
      </v-tab-item> -->
      <!-- <v-tab-item>
        <v-card-text>
          <UsersComments />
        </v-card-text>
      </v-tab-item> -->
      <!-- <v-tab-item>
        <v-card-text>
          <SomeRunners />
        </v-card-text>
      </v-tab-item> -->
    </v-tabs-items>
  </div>
</template>

<script>
import OrganisationTable from "@/components/AdminPanelFinexpert/OrganisationTable.vue";
import UsersTableUM from "@/components/AdminPanelFinexpert/UsersTableUM.vue";
import EditFirmTarifs from "@/components/AdminPanelFinexpert/EditFirmTariffs.vue";

export default {
  components: {
    OrganisationTable,
    UsersTableUM,
    // AddTariff,
    // EditTariffs,
    EditFirmTarifs,
    // BankRating,
    // UsersComments,
    // SomeRunners
  },
  data() {
    return {
      tab: 1,
      items: [
        "Организации",
        "Все пользователи системы",
        // "Тарифы",
        "Тарифы Организаций",
        // "Рейтинг Банков",
        // "Комментарии пользователей",
        // "Принудительный запуск",
      ],
    };
  },

  methods: {
    ChangeTabUM() {
      this.$store
        .dispatch("ChangeTabUM", this.tab)
        .then(() => { })
        .catch((error) => {
          alert(error);
        });
    },
  },
  computed: {},
  async mounted() {
    this.setTitle("Панель администратора Finexpert");
    this.tab = localStorage.getItem('ADMIN_PANEL_FIN_TABS') ? parseInt(localStorage.getItem('ADMIN_PANEL_FIN_TABS')) : 0
  },
  watch: {
    tab() {

      localStorage.setItem('ADMIN_PANEL_FIN_TABS', this.tab)
    }
  }
};
</script>

<style lang="sass"></style>
